/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Planned Missions container
Author: Deimos Space UK

Version: 1.0
*/
import React from 'react'
import { Col, Container, Row, Button } from "reactstrap";
import MissionPlannedList from '../components/MissionsPlanned';
import { Link } from "react-router-dom";


export default function PlannedMissions() {

  return (
    <Container>
      <Row className="pt-3">
        <Col>
          <h3 style={{ color: '#003247' }}>Planned Missions</h3>
        </Col>
        <Col>
          <Button style={{ background: '#003247' }} className="float-right">
            <Link to="/impact-evaluation/input" style={{ color: '#fff' }}>Create</Link>
          </Button>
        </Col>
      </Row>
      <Row className='mt-3' >
        <Col>
          <MissionPlannedList />
        </Col>
      </Row>
    </Container>
  )
}
